import { t } from 'i18next';
import * as yup from 'yup';

export default class AdminRequestCostBearerCreate {
    constructor({
        name = "",
        showLabel = "",
        value = "",
        message = "",
        includedInAGI = false,
    } = {}) {
        this.name = name;
        this.showLabel = showLabel;
        this.value = value;
        this.message = message;
        this.includedInAGI = includedInAGI;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const fieldRequired = t('validationMessage.fieldRequired');

        const attributes = {
            name: {
                'label': t('costBearer.name'),
                'type': 'text',
                'required': true,
                'validation': yup.string()
                    .required(fieldRequired)
            },
            showLabel: {
                'label': t('costBearer.showLabel'),
                'type': 'text',
                'required': false,
                'validation': yup.string()
                    .max(255, 'validationMessage.showLabelMaxLength'),
            },
            value: {
                'label': t('costBearer.value'),
                'type': 'text',
                'required': true,
                'validation': yup
                    .string()
                    .required(fieldRequired)
                    .matches(/^[0-9]+$/, t('validationMessage.valueNumeric'))
                    .max(6, t('validationMessage.max6digits'))
                    .test('maxValue', t('validationMessage.max999999'), (val) => {
                        return !val || parseInt(val, 10) <= 999999;
                    }),
            },

            message: {
                'label': t('costBearer.message'),
                'type': 'textarea',
                'required': false,
                'validation': yup.string()
                    .max(1000, 'validationMessage.messageMaxLength'),
            },
            includedInAGI: {
                'label': t('costBearer.includedInAGI'),
                'type': 'checkbox',
                'required': false,
                'validation': yup.boolean(),
            },
        };

        if (validationSchema === true) {
            const schema = yup.object().shape({
                name: attributes.name.validation,
                showLabel: attributes.showLabel.validation || yup.string(),
                value: attributes.value.validation,
                message: attributes.message.validation,
            });
            return schema;
        }

        return attributes;
    }
}